import YouTube from "react-youtube";
import { useState, useEffect } from "react";
import "./YoutubeEmbed.css";

export default function YoutubeEmbed({ videoId, onVideoEnd }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [thumbnail, setThumbnail] = useState("");

  const opts = {
    width: "100%",
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
    },
  };

  return (
    <div className="youtube-player">
      <div className="youtube-iframe-wrapper">
        <YouTube
          videoId={videoId}
          className="youtube-iframe"
          opts={opts}
          onEnd={() => {
            setIsPlaying(false);
            if (onVideoEnd) onVideoEnd();
          }}
        />
      </div>
    </div>
  );
}
